import React, { useState, useEffect } from 'react'
import { Button, Col, Modal, FormGroup, Label, Input } from 'reactstrap'
import { HeaderModal } from '../Basicos'

const ModalAtualizarAula = ({ isOpen, atualizarAula, periodosLetivos = [], alocacoes = [] }) => {
    const [periodoSelecionado, setPeriodoSelecionado] = useState('');

    useEffect(() => {
        if (periodosLetivos && periodosLetivos.length > 0) {
            // Tenta pré-selecionar o período letivo vigente, se houver
            const vigente = periodosLetivos.find(p => p.vigente);
            if (vigente) {
                setPeriodoSelecionado(vigente.id);
            } else {
                setPeriodoSelecionado(periodosLetivos[0].id);
            }
        }
    }, [periodosLetivos]);

    const handleSalvar = (atualizaHoje) => {
        atualizarAula(atualizaHoje, false, periodoSelecionado);
    };

    const formatarData = (dataStr) => {
        if (!dataStr) return '';
        const partes = dataStr.split('-');
        if (partes.length === 3) {
            return `${partes[2]}/${partes[1]}/${partes[0]}`;
        }
        return dataStr;
    };

    const formatarHorario = (inicio, fim) => {
        if (!inicio) return '';
        const extrairHoraMinuto = (tempo) => {
            if (!tempo) return '';
            const partes = tempo.split(':');
            if (partes.length >= 2) return `${partes[0]}:${partes[1]}`;
            return tempo;
        };
        const inicioFormatado = extrairHoraMinuto(inicio);
        const fimFormatado = extrairHoraMinuto(fim);
        if (inicioFormatado && fimFormatado) {
            return ` às ${inicioFormatado} - ${fimFormatado}`;
        }
        if (inicioFormatado) {
            return ` às ${inicioFormatado}`;
        }
        return '';
    };

    // Filtra as alocações de acordo com o período letivo selecionado no select
    const alocacoesFiltradas = alocacoes.filter(
        (aloc) => String(aloc.periodo_letivo_id) === String(periodoSelecionado)
    );

    return (
        <Modal isOpen={isOpen} className="modal-atualizar-local" size="md">
            <HeaderModal
                icon={false}
                titulo={'Salvar Alterações'}
                sm={12}
                colClassName="modalConsulta__menu atualizar-aula"
            />
            <Col sm={12} style={{ padding: '20px 30px' }}>
                {periodosLetivos && periodosLetivos.length > 0 && (
                    <FormGroup>
                        <Label for="periodoLetivoSelect" style={{ fontWeight: 'bold', color: 'var(--cor-text-primario)' }}>
                            Selecione o Período Letivo:
                        </Label>
                        <Input
                            type="select"
                            name="periodoLetivo"
                            id="periodoLetivoSelect"
                            value={periodoSelecionado}
                            onChange={(e) => setPeriodoSelecionado(e.target.value)}
                        >
                            {periodosLetivos.map(periodo => (
                                <option key={periodo.id} value={periodo.id}>
                                    {periodo.descricao} {periodo.vigente ? '(Vigente)' : ''}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                )}

                {alocacoes && alocacoes.length > 0 && (
                    <div style={{ marginBottom: '16px', marginTop: '16px' }}>
                        <div style={{ fontSize: '0.8rem', fontWeight: '600', color: 'var(--cor-text-secundario)', marginBottom: '6px', textAlign: 'left' }}>
                            Aulas alocadas encontradas:
                        </div>
                        <div style={{
                            maxHeight: '150px',
                            overflowY: 'auto',
                            border: '1px solid #e9ecef',
                            borderRadius: '4px',
                            padding: '8px',
                            backgroundColor: '#f8f9fa'
                        }}>
                            {alocacoesFiltradas.length > 0 ? (
                                alocacoesFiltradas.map((aloc, idx) => (
                                    <div key={idx} style={{
                                        fontSize: '0.78rem',
                                        padding: '4px 0',
                                        borderBottom: idx < alocacoesFiltradas.length - 1 ? '1px solid #e9ecef' : 'none',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        color: 'var(--cor-text-principal)'
                                    }}>
                                        <span><strong>Turma:</strong> {aloc.turma_descricao || 'Todos'}</span>
                                        <span style={{ color: 'var(--cor-text-secundario)', marginLeft: '8px' }}>
                                            {formatarData(aloc.data)}{formatarHorario(aloc.horario_inicio, aloc.horario_fim)}
                                        </span>
                                    </div>
                                ))
                            ) : (
                                <div style={{ fontSize: '0.78rem', color: 'var(--cor-text-secundario)', textAlign: 'center', padding: '8px 0' }}>
                                    Nenhuma aula alocada neste período letivo.
                                </div>
                            )}
                        </div>
                    </div>
                )}

                <div style={{ marginTop: '20px', fontSize: '0.9rem', color: 'var(--cor-text-secundario)', textAlign: 'center' }}>
                    Deseja atualizar as aulas de hoje?
                </div>
            </Col>

            <Col sm={12} style={{ padding: '8px 30px 20px' }}>
                <Button outline color="primary" onClick={() => handleSalvar(false)} className={"float-left btnHeader btnHeader-danger m-0"} style={{ minWidth: '100px' }}>
                    NÃO
                </Button>
                <Button outline color="danger" onClick={() => handleSalvar(true)} className={"float-right btnHeader m-0"} style={{ minWidth: '100px' }}>
                    SIM
                </Button>
            </Col>
        </Modal >
    )
}

export default ModalAtualizarAula